<div class="spacing--margin-horizontal spacing--margin-vertical">
  <agr-summary-card [title]="'balance-summary.title' | translate" [canExpand]="true">
    <app-table [config]="summaryTableConfig" data-test="balance-summary-table"></app-table>
  </agr-summary-card>
</div>
